import React from 'react'
import styled from 'styled-components'
import moment from '../../../lib/moment.js'
import shortid from 'shortid'
import get from 'lodash/get'
import { FONTS } from '../../../constants'

export const DateHeader = (props) => {
  const activeTab = get(props, 'activeTab')
  return (
    <Column>
      <Total>Total Hours</Total>
      { activeTab === 2 && <Total>Total MDs</Total> }
      { activeTab === 2 && <Total>Total WMD</Total> }
      {get(props, 'dates', []).map(date => {
        const isToday = date.isSame(moment(), 'day')
        return (
          <Cell
            key={ shortid() }
            isToday={ isToday }
            style={ { borderTopColor: '#ad191f', borderTopWidth: isToday ? 5 : 0 } }
          >
            <Day
              isToday={ isToday }
              style={ { marginTop: isToday ? -5 : 0 } }
            >
              { date.format('dd') }
            </Day>
            <Date isToday={ isToday }>{ date.date() }</Date>
          </Cell>
        )
      })}
    </Column>
  )
}

export const SelectProjectHeader = (props) => {
  return (
    <Column>
      <Total>Total</Total>
      {get(props, 'dates', []).map(date => {
        const isToday = date.isSame(moment(), 'day')
        return (
          <Cell
            key={ shortid() }
            isToday={ isToday }
            style={ { borderTopColor: '#ad191f', borderTopWidth: isToday ? 5 : 0 } }
          >
            <Day
              isToday={ isToday }
              style={ { marginTop: isToday ? -5 : 0 } }
            >
              { date.format('dd') }
            </Day>
            <Date isToday={ isToday }>{ date.date() }</Date>
          </Cell>
        )
      })}
    </Column>
  )
}

const Column = styled.div`
  height: 100%;
  background-color: #FFFFFF;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const Cell = styled.div`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: 10px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Total = styled.span`
  width: 50px;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: 10px;
  text-align: center;
  margin-top: 5px;
`
const Date = styled.div`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  color: ${(props) => {
    if (props.isToday) return '#ad191f'
    return 'black'
  }};
`
const Day = styled.div`
  font-family: ${FONTS.GOTHAM} !important;
  color: ${(props) => {
    if (props.isToday) return '#ad191f'
    return 'black'
  }};
`



// WEBPACK FOOTER //
// ./src/components/timesheet/helpers/header.js